import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import HomeIcon from "./icons/Home.svg";
import ProductsIcon from "./icons/Products.svg";
import SubscriptionIcon from "./icons/Subscription.svg";
import RdHubIcon from "./icons/RD-Hub.svg";
import styles from "./styles.module.scss";
const MobileNavigation = () => {
    const location = useLocation();
    const isProfile = location.pathname.indexOf("app") > -1;
    const options = [
        {
            title: "Home",
            link: "/app/home",
            icon: HomeIcon,
        },
        {
            title: "Products",
            link: "/app/products/",
            icon: ProductsIcon,
        },
        {
            title: "Subscription",
            link: "/app/subscription",
            icon: SubscriptionIcon,
        },
        {
            title: "RD Hub",
            link: "/app/dietitian",
            icon: RdHubIcon,
        }
    ];
    return (_jsx("div", { className: styles.mobile_nav_wrapper, children: _jsx("div", { className: styles.mobile_nav, children: options.map((item) => isProfile ? (_jsxs(NavLink, { className: styles.link, activeClassName: styles.active, to: item.link, children: [_jsx("img", { src: item.icon, alt: item.title }), _jsx("span", { className: styles.link_name, children: item.title })] }, item.title)) : (_jsxs("a", { href: item.link, className: `${styles.link} ${item.link === location.pathname ? styles.active : ""}`, children: [_jsx("img", { src: item.icon, alt: item.title }), _jsx("span", { className: styles.link_name, children: item.title })] }, item.title))) }) }));
};
export default MobileNavigation;
